import { render } from "./DefaultTunes.vue?vue&type=template&id=525ae87e&scoped=true"
import script from "./DefaultTunes.vue?vue&type=script&lang=js"
export * from "./DefaultTunes.vue?vue&type=script&lang=js"

import "./DefaultTunes.vue?vue&type=style&index=0&id=525ae87e&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525ae87e"]])

export default __exports__